import { Pipe, PipeTransform } from "@angular/core";
import { utcToRelativeTime } from 'app/shared/helpers/utils';

@Pipe({
    name: 'relativeTime',
    standalone: false
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) { return ''; }
    const iso = value instanceof Date ? value.toISOString() : value;
    return utcToRelativeTime(iso);
  }
}